import { pickBy, startsWith, reduce, get } from 'lodash'

export const getJsonFromUrl = () => {
  const query = window.location.search.substr(1)
  const result = {}

  query.split('&').forEach((part) => {
    const item = part.split('=')
    const key = item[0]
    const decoded = decodeURIComponent(item[1]).split(',')
    let value
    if (decoded.length > 1) {
      value = []
      decoded.forEach((entry) => value.push(entry))
    } else {
      value = get(item, '1')
    }
    result[key] = value
  })
  return result || []
}

export const getParamsFromUrl = (prefix) => {
  let params = pickBy(getJsonFromUrl(), (value, key) => startsWith(key, prefix))
  /* eslint-disable no-param-reassign */
  params = reduce(
    params,
    (result, value, key) => {
      key = key.replace(new RegExp(prefix, 'i'), '')
      result[key] = value
      return result
    },
    {},
  )

  return params || {}
}
